import { useState, useEffect } from 'react';
import CreateAction from '../../../components/operational/createAction';
import { translate } from '../../../utils/language';

const RealtimeReportTab = ({ dateRange }) => {
  const [data, setData] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const getDatas = async () => {
    const response = await CreateAction({
      method: 'POST',
      path: `/realtimeReport`,
      showPreLoader: false,
      isFileUploading: false,
      hideToastMessages: true,
    });

    if (response?.error) return;
    if (response?.result?.resultData?.firebaseService === 'NEED_PERMISSION') {
      setErrorMessage('NEED_PERMISSION');
      return;
    }

    if (!response?.result?.resultData) return;

    setErrorMessage('');
    setData(response?.result?.resultData);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      getDatas();
    }, 15000);
    getDatas();

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="w-[100%]  flex" style={{ borderRight: '1px solid #E5E5E5' }}>
      <div className="flex w-[100%]" style={{ overflowX: 'auto' }}>
        <div
          className="px-[25px] py-[30px] flex flex-row items-center w-[100%]"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '10px',
            alignItems: 'center',
            fontSize: '27px',
            color: '#494949',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: '17px', color: '#494949' }}>Anlık Ziyaretçi</div>
          </div>
          {errorMessage ? (
            <div className="p-2">
              <div className="text-red-500 text-center text-[16px]">{translate(errorMessage)}</div>
            </div>
          ) : (
            <div className="flex gap-2 items-center">
              <div>{data}</div>
              <div className="relative w-[35px] h-[35px]">
                <span className="animate-fade-out-expanding top-[11px] left-[11px] w-[13px] h-[13px] bg-[rgba(34,197,93,0.5)] rounded-full absolute"></span>
                <span
                  style={{ animationDelay: '1s' }}
                  className="animate-fade-out-expanding top-[11px] left-[11px] w-[13px] h-[13px] bg-[rgba(34,197,93,0.5)] rounded-full absolute"
                ></span>
                <span
                  style={{ animationDelay: '2s' }}
                  className="animate-fade-out-expanding top-[11px] left-[11px] w-[13px] h-[13px] bg-[rgba(34,197,93,0.5)] rounded-full absolute"
                ></span>

                <span className="top-[11px] left-[11px] w-[13px] h-[13px] bg-[rgb(34,197,93)] rounded-full absolute opacity-100"></span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RealtimeReportTab;
